import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useInRouterContext } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

function SafeRouter({ children }) {
  try {
    const inRouter = useInRouterContext();
    if (inRouter) {
      return <>{children}</>;
    }
  } catch (e) {
    // Ignorer fejl og fald tilbage til BrowserRouter
  }
  return <BrowserRouter>{children}</BrowserRouter>;
}

createRoot(document.getElementById('root')).render(
  <SafeRouter>
    <App />
  </SafeRouter>
)

